import { action, computed, observable, set } from "mobx";
import Address from "~/models/Address";
import Currency from "~/constants/Credit/Currency";
import Model from "~/models/Model";
import UiMeet3dLevel from "~/constants/UiMeet3d/UiMeet3dLevel";

class Provider extends Model {
  /**
   * @property {number|null}
   */
  @observable providerId = null;

  /**
   * @property {string|null}
   */
  @observable name = null;

  /**
   * @property {string|null}
   */
  @observable company = null;

  /**
   * @property {string|null}
   */
  @observable email = null;

  /**
   * @property {string|null}
   */
  @observable contactPhone = null;

  /**
   * @property {string|null}
   */
  @observable logoUrl = null;

  /**
   * @property {string|null}
   */
  @observable logoPathWeb = null;

  /**
   * @property {string|null}
   */
  @observable website = null;

  /**
   * @property {string}
   */
  @observable orderFormUrl = null;

  /**
   * @property {boolean}
   */
  @observable enableClientYoutubeSetup = true;

  /**
   * @property {boolean}
   */
  @observable pocketWebsiteEnabled = false;

  /**
   * @property {number|null}
   */
  @observable defaultCreditCardId = null;

  /**
   * @property {string|null}
   */
  @observable standardCost = null;

  /**
   * @property {number|null}
   */
  @observable discountCreditCost = null;

  /**
   * @property {number|null}
   */
  @observable discountQuantity = null;

  /**
   * @property {bool}
   */
  @observable isMyUrbanimmersive = false;

  /**
   * @property {bool}
   */
  @observable isTrial = false;

  /**
   * @property {string|null}
   */
  @observable locale = null;

  /**
   * @property {number|null}
   */
  @observable lowCreditBalanceNotificationThreshold = null;

  /**
   * @property {number|null}
   */
  @observable lowCreditBalanceThreshholdAutoPurchaseAmount = 0;

  /**
   * @property {bool}
   */
  @observable allowNegativeCreditBalance = false;

  /**
   * @property {number}
   */
  @observable billingDayOfMonth = 1;

  /**
   * @property {bool}
   */
  @observable enableClientPanelSubscriptions = true;

  /**
   * @property {Object}
   */
  @observable uiMeet3dSettings = {};

  /**
   * @property {bool}
   */
  @observable isUsingExternalInvoicingForSubscriptions = false;

  /**
   * Set new data to our model
   * @override
   * @param {object} data
   */
  @action
  setData(data) {
    const { address, ...rest } = data;
    set(this, rest);

    this.address = address ? new Address(address) : null;
  }

  @computed
  get currency() {
    return this.address && this.address.country === "Canada" ? Currency.CAD : Currency.USD;
  }

  @computed
  get uiMeet3dLevelCoalesced() {
    return this.uiMeet3dLevel !== null ? this.uiMeet3dLevel : UiMeet3dLevel.VIDEO;
  }
}

export default Provider;
